import {createActionGroup, emptyProps} from '@ngrx/store';
import {ROUTER_FEATURE_KEY} from '@aviary/store/router/router.types';
import {Sort} from '@angular/material/sort';
import {Params} from '@angular/router';
import {OneOrArrayOf} from '@aviary/store/utility-type.helpers';

// For each app to call in an adapter file, using its own RouteName type.
export function createRouterActions<RouteNameType extends string = string>() {
  return createActionGroup({
    source: ROUTER_FEATURE_KEY,
    events: {
      'Navigate To': (routeName: RouteNameType, params?: Params) => ({routeName, params: params ?? {}}),
      'Navigate To Url': (url: string) => ({url}),
      'Replace Route With': (routeName: RouteNameType, params?: Params) => ({routeName, params: params ?? {}}),

      'Update Search Params': (query: string, queryType: string, destinationRouteName: RouteNameType, typeParamOverride?: string, clearFilters?: boolean) =>
        ({query, queryType, destinationRouteName, typeParamOverride, clearFilters}),
      'Update Pagination Params': (page: number, pageSize: number) => ({page, pageSize}),
      'Update Sort Params': (angularSortState: Sort, entityId?: number) => ({angularSortState, entityId}),
      'Add Filter Param': (name: string, value: string) => ({name, value}),
      'Clean Add Filter Param': (name: string, value: string) => ({name, value}),
      'Clear All Filters': emptyProps(),
      'Remove Filter Param': (name: string) => ({name}),
      'Remove Query Params': (names: OneOrArrayOf<string>) => ({names}),
      'Update Search Term And Target Params': (value: string, searchTarget: string) => ({value, searchTarget}),
      'Remove Search Term And Target Params': emptyProps()
    }
  });
}

// For Aviary use only.
export const RouterActions = createRouterActions<string>();
